import {useQuery} from "@tanstack/react-query";
import {DT0Format} from "../utils/StaticVariable";
import {GLOBAL_HD_DTU_ID} from "../utils/common";
import moment from "moment";
import Api, {DEFAULT_ERROR_MESSAGE} from "../api/Api";
import {QUERY_KEYS} from "./queryKeys";
import {IGetMetadata} from "../types/metadata";

export const useTimeSeriesQuery = (
  datasetId: string,
  coordinates: number[],
  pointName: string,
  timeStepInterval: string,
  metadata: Partial<IGetMetadata>,
  orderId: string,
  enabled: boolean
) => {
  const requiresOrderId = datasetId.includes('CMEMS');

  return useQuery({
    queryKey: [
      QUERY_KEYS.plot.timeseries,
      datasetId,
      coordinates,
      pointName,
      timeStepInterval,
    ],
    queryFn: async () => {
      if (metadata?.IsOffline || !metadata.TimeDefinition || !metadata) {
        return {success: false, error: DEFAULT_ERROR_MESSAGE}
      }

      const timeRange = metadata.TimeDefinition.split(';')

      try {
        const data = await Api.chart.getBasicChartV2(
          orderId,
          pointName,
          datasetId,
          moment(timeRange[1]).subtract(1, 'year').format(DT0Format),
          timeRange[1],
          coordinates.join(),
          datasetId === GLOBAL_HD_DTU_ID ? parseInt(timeStepInterval) : 60
        )

        if (!data) {
          return {success: false, error: DEFAULT_ERROR_MESSAGE}
        }

        if (data.Error) {
          return {success: false, error: data.Error}
        }

        return {
          success: true,
          data: {
            ...data,
            ItemsInfo: metadata.ItemsInfo,
            DefaultDirectionShortName: metadata.DefaultDirectionShortName,
            DefaultValueShortName: metadata.DefaultValueShortName,
          }
        }
      } catch (error: any) {
        let errorMessage = DEFAULT_ERROR_MESSAGE

        if (error?.response?.data?.Message) {
          errorMessage = error.response.data.Message
        } else if (error?.message) {
          errorMessage = error.message
        }

        return {
          success: false,
          error: errorMessage
        }
      }
    },
    enabled: !metadata?.IsOffline && !!datasetId && !!coordinates.length && enabled && (!requiresOrderId || !!orderId),
  })
}
